import React from "react"
import NavContextProvider from "./context/NavContext"

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <NavContextProvider>{element}</NavContextProvider>
    </>
  )
}
